import { Align, FlexItem } from '@bytel/trilogy-react';

import { FaiTabsEnum } from '@app-types/home-fai';
import { FaiType } from '@app-types/plan';

import { RocCard } from '@components/roc-card/roc-card';

import { paths } from '@helpers/path';
import { sendTracking } from '@helpers/tracking';

import { OnClickEvent } from '@trilogy-ds/react/lib/events/OnClickEvent';

interface RocSelectorProps {
    plan?: FaiType;
    onAddToCart: (gencode: string) => void;
    hasSiblingHat?: boolean;
    activeTab?: FaiTabsEnum;
    showComparatorCheckbox?: boolean;
    showDetailsButton?: boolean;
}

export function RocSelector({ plan, onAddToCart, activeTab, ...props }: Readonly<RocSelectorProps>) {
    const getCtaContent = (plan?: FaiType & { isEligible?: boolean }) => {
        if (!plan) {
            return undefined;
        }

        if (plan.isEligible === undefined) {
            return {
                href: paths.eligibilityTest({
                    gamme: `${plan.rangeNg}_${plan.commercialSeries}_${plan.technology.toLowerCase()}`,
                    hash: activeTab,
                }),
                text: 'Choisir cette box',
                disabled: false,
            };
        }

        return {
            onClick: async (e: OnClickEvent) => {
                const event = e as MouseEvent;
                if (!plan.isEligible) {
                    event.preventDefault();
                    return;
                }

                sendTracking(false, {
                    action: 'Clic_redirection',
                    category: 'Choix_box_internet',
                    name: 'Choisir_cette_offre',
                    universe: 'Boutique_fai',
                });
                onAddToCart(plan.gencode);
            },
            text: plan.isEligible ? 'Ajouter au panier' : 'Offre non éligible',
            disabled: !plan.isEligible,
        };
    };

    if (!plan) {
        return null;
    }

    return (
        <FlexItem
            align={Align.STRETCH}
            size={{ mobile: 12, tablet: 6, desktop: 4 }}
            data-cy={`${plan.rangeNg}_${plan.commercialSeries}`}
        >
            <RocCard shadowless={true} plan={plan} cta={getCtaContent(plan)} {...props} />
        </FlexItem>
    );
}
